import { registerLanguage } from '../_.contribution.js';

registerLanguage({
  id: "bat",
  extensions: [".bat", ".cmd"],
  aliases: ["Batch", "bat"],
  loader: () => import('./bat.js')
});
